import api from "./api";
import { AxiosResponse } from "axios";

export interface MeResponse {
  email: string;
  plan: "free" | "pro" | "premium";
  stripeSubscriptionStatus: "active" | "canceling" | "free";
  currentPeriodEnd: string | null;
  stripeCustomerId?: string;
  submissionsToday: number;
  maxSubmissionsPerDay: number;
  maxWordsPerSubmission: number;
}


export const getMe = (): Promise<AxiosResponse<MeResponse>> =>
  api.get("/api/users/me");

export const cancelSubscription = async (data: { reason: string }) => {
  return await api.post("/api/billing/cancel", data); 
};

export const deleteAccount = () =>
  api.delete("/api/users/me");
